import { render, staticRenderFns } from "./UnSuspendApproval.vue?vue&type=template&id=f40660ee&scoped=true"
import script from "./UnSuspendApproval.vue?vue&type=script&lang=js"
export * from "./UnSuspendApproval.vue?vue&type=script&lang=js"
import style0 from "./UnSuspendApproval.vue?vue&type=style&index=0&id=f40660ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f40660ee",
  null
  
)

export default component.exports